import type { IRestModel } from "@nkr/utils/rest-api";
import { RestApi } from "@nkr/utils/rest-api";
import { LookupApi } from "@nkr/utils/rest-api/LookupApi";

export interface IInvoiceBackgroundTask extends IRestModel {
    id              : number | string,
    lastRunDateTime ?: string,
    lastRunStatus   ?: string,
    percentComplete ?: string
}

export const useInvoiceBackgroundTask = () => {
    const lookup        = new LookupApi<IInvoiceBackgroundTask>(`${__API__}/invoice/background-task`);
    const lookupHooks   = lookup.makeHooks();
    const instance      = new RestApi<IInvoiceBackgroundTask, IInvoiceBackgroundTask>(`${__API__}/invoice/background-task`);
    const hooks         = instance.makeHooks();
    const create        = hooks.useCreate();
    return {
        useGetData  : lookupHooks.useGetData,
        refresh     : lookupHooks.refresh,
        initiate    : create.submit
    }
};